import { useEffect } from 'react'

const SCRIPT_ID = 'alinova-structured-data'

/**
 * Inserta datos estructurados (JSON-LD) de tipo Organization/LocalBusiness
 * una sola vez en <head>. No agrega ningún elemento visible ni modifica
 * texto, imágenes o estilos de la página — es metadata exclusiva para
 * motores de búsqueda (rich results, panel de negocio local).
 *
 * La información usada (nombre legal, teléfono, ciudad) ya es pública en
 * el sitio (botón de WhatsApp, modal de política de privacidad).
 */
export function useStructuredData() {
  useEffect(() => {
    if (document.getElementById(SCRIPT_ID)) return

    const data = {
      '@context': 'https://schema.org',
      '@type': 'MedicalBusiness',
      name: 'Alinova',
      legalName: 'ADL Importaciones S.A.S.',
      alternateName: 'Labtek Soluciones Dentales 3D',
      description:
        'Fabricante colombiano de alineadores invisibles para odontólogos y ortodoncistas, con validación clínica y certificación INVIMA.',
      url: 'https://alinova.co',
      telephone: '+573016539065',
      areaServed: {
        '@type': 'Country',
        name: 'Colombia',
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Bogotá',
        addressCountry: 'CO',
      },
      sameAs: [
        'https://www.instagram.com/alinova.co/',
        'https://www.tiktok.com/@alinovaortodoncia',
        'https://www.facebook.com/profile.php?id=61590494495467',
      ],
      medicalSpecialty: 'Dentistry',
      audience: {
        '@type': 'Audience',
        audienceType: 'Odontólogos y ortodoncistas',
      },
    }

    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.type = 'application/ld+json'
    script.text = JSON.stringify(data)
    document.head.appendChild(script)
  }, [])
}
